import { BaseDadosScreen } from "@/screens/financeiro/configuracoes/base-dados";

export function FinanceiroBaseDadosPage() {
  return <BaseDadosScreen />;
}
